/*
 * "Try it on near you" (snippets/dealer-nearby.liquid) on helmet product pages.
 * Needs assets/dealer-core.js. Reads the dealer locator's config from the
 * dealer page on first use (cached for 30 minutes), then lists the nearest
 * open-for-business locations. With a location saved from an earlier search
 * (here or on the dealer page) it fills in on load without asking.
 */
(function () {
  var KD = window.KabutoDealers;
  if (!KD) return;
  var esc = KD.esc;
  var P = 'dealer-nearby__';

  function init(root) {
    var pageUrl = root.getAttribute('data-page-url') || '/pages/kabuto-dealers';
    var count = parseInt(root.getAttribute('data-count'), 10) || 3;
    var form = root.querySelector('[data-dealer-nearby-form]');
    var input = root.querySelector('[data-dealer-nearby-query]');
    var locateBtn = root.querySelector('[data-dealer-nearby-locate]');
    var status = root.querySelector('[data-dealer-nearby-status]');
    var list = root.querySelector('[data-dealer-nearby-list]');
    var allLink = root.querySelector('[data-dealer-nearby-all]');
    var allLabel = root.querySelector('[data-dealer-nearby-all-label]');
    var dataPromise = null;
    var cfg = null;

    function data() {
      if (!dataPromise) {
        dataPromise = KD.loadConfigFromPage(pageUrl).then(function (c) {
          cfg = c;
          return KD.loadFromConfig(c);
        });
        dataPromise.catch(function () { dataPromise = null; });
      }
      return dataPromise;
    }

    function linkTo(params) {
      var u = new URL(pageUrl, location.origin);
      Object.keys(params).forEach(function (k) { u.searchParams.set(k, params[k]); });
      return u.pathname + u.search;
    }

    function render(all, origin) {
      var now = new Date();
      var near = all
        .filter(function (l) { return l.lat != null && !l.closed; })
        .map(function (l) { l.distance = KD.distanceMi(origin, l); l.open = KD.openState(l, now); return l; })
        .sort(function (a, b) { return a.distance - b.distance; })
        .slice(0, count);
      var nearParam = origin.kind === 'geo' ? origin.lat.toFixed(2) + ',' + origin.lng.toFixed(2) : origin.label;
      status.innerHTML = 'Nearest to <strong>' + esc(origin.label) + '</strong> · <button type="button" class="' + P + 'change" data-dealer-nearby-change>Change</button>';
      list.innerHTML = near.map(function (l) {
        var dealer = l.kind === 'dealer';
        // Same badge rule as the dealer page: authorized dealers show only their own badge (e.g. Headquarters), retail shows the brand.
        var tag = dealer
          ? (l.badge ? '<span class="badge ' + P + 'tag">' + esc(l.badge) + '</span>' : '')
          : '<span class="' + P + 'tag ' + P + 'tag--retail">' + esc(l.brand) + '</span>';
        var actions = '<a class="' + P + 'directions" href="' + esc(KD.directionsUrl(l)) + '" target="_blank" rel="noopener">' + KD.ICON.directions + esc(cfg.directionsLabel || 'Directions') + '<span class="visually-hidden"> to ' + esc(l.name) + '</span></a>';
        if (l.tel) actions += '<a class="' + P + 'link" href="' + esc(l.tel) + '">' + KD.ICON.phone + esc(l.phone) + '</a>';
        var note = l.callAhead ? '<p class="' + P + 'note">' + esc(cfg.callAheadText || 'Call ahead to check stock') + '</p>' : '';
        return '<li class="' + P + 'item"><article class="' + P + 'card' + (dealer ? ' ' + P + 'card--dealer' : '') + '">' +
          '<div class="' + P + 'card-top">' + tag + '<span class="' + P + 'distance">' + KD.formatDistance(l.distance) + '</span></div>' +
          '<p class="' + P + 'name"><a href="' + esc(linkTo({ store: l.id })) + '">' + esc(l.name) + '</a></p>' +
          '<p class="' + P + 'address">' + KD.addressHtml(l, cfg) + '</p>' +
          KD.openHtml(l, P) +
          '<div class="' + P + 'actions">' + actions + '</div>' + note + '</article></li>';
      }).join('');
      list.hidden = !near.length;
      form.hidden = true;
      allLink.setAttribute('href', linkTo({ near: nearParam }));
      allLabel.textContent = 'See all locations near ' + origin.label;
    }

    function run(originPromise, kind) {
      status.textContent = 'Finding stores…';
      Promise.all([data(), originPromise]).then(function (res) {
        var all = res[0];
        var origin = res[1];
        if (!origin) {
          status.textContent = 'Couldn’t find that place. Try a ZIP code.';
          form.hidden = false;
          return;
        }
        KD.origin.set(origin);
        render(all, origin);
        if (kind) KD.track('dealer_nearby_search', { kind: kind, query: kind === 'geo' ? '' : origin.label });
      }).catch(function (e) {
        console.error('Dealer list failed to load', e);
        status.textContent = 'Store list unavailable right now.';
        form.hidden = false;
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (!q) { input.focus(); return; }
      run(data().then(function () { return KD.lookup(q, cfg); }), /^\d{5}/.test(q) ? 'zip' : 'place');
    });

    locateBtn.addEventListener('click', function () {
      if (!navigator.geolocation) { status.textContent = 'Your browser can’t share your location. Enter a ZIP code instead.'; return; }
      locateBtn.setAttribute('aria-busy', 'true');
      run(new Promise(function (resolve) {
        navigator.geolocation.getCurrentPosition(function (pos) {
          locateBtn.removeAttribute('aria-busy');
          resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude, label: 'your location', kind: 'geo' });
        }, function () {
          locateBtn.removeAttribute('aria-busy');
          resolve(null);
        }, { timeout: 10000, maximumAge: 600000 });
      }), 'geo');
    });

    root.addEventListener('click', function (e) {
      if (!e.target.closest('[data-dealer-nearby-change]')) return;
      form.hidden = false;
      list.hidden = true;
      status.textContent = '';
      input.focus();
    });

    form.hidden = false;
    var saved = KD.origin.get();
    if (saved) run(Promise.resolve(saved), null);
  }

  function boot() {
    document.querySelectorAll('[data-dealer-nearby]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
